"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookPixel = void 0;
var FacebookPixel = /** @class */ (function () {
    function FacebookPixel(pixelId) {
        this.pixelId = pixelId;
        console.log("FacebookPixel with ".concat(this.pixelId));
    }
    FacebookPixel.prototype.add = function () {
        console.log('Add facebook pixel');
        if (!fbq) {
            console.error('fbq not found');
            return;
        }
        fbq('init', this.pixelId);
        var imgSrc = "https://www.facebook.com/tr?id=".concat(this.pixelId, "&ev=PageView&noscript=1");
        this.addImg(imgSrc);
    };
    FacebookPixel.prototype.addImg = function (url) {
        var img = new Image();
        img.src = url;
        img.width = 1;
        img.height = 1;
        img.style.display = 'none';
        document.head.appendChild(img);
    };
    return FacebookPixel;
}());
exports.FacebookPixel = FacebookPixel;
